module.exports = __webpack_public_path__ + "img/ro_float.de0d2261.png";